module.exports = __webpack_public_path__ + "img/sem_imagem.2ce20ce3.gif";